import { Button, message } from "antd";
import React, { useEffect } from "react";
import { YhBox } from "../../../../components/YhBox";
import { DescriptionColorEnum, IDescription } from "../../../../components/YhBox/Types";
import { BillDataTable } from "./DataTable";
import { WriteoffDrawer } from "./WriteoffDrawer";
import { PageHeader } from './PageHeader'
import { useBillSupplierModel } from "../billSupplierModel";
import { orgService } from "../../../base/org/orgService";
import { beService } from "../../../base/be/beService";
import { labelsType } from "../../../cash/pay/cashPayModel";
import { useGlobalModel } from "@/model/globalModel";
import { DictCodeEnmu } from "@/types/FmsDictEnums";
import { ResourceAuthEnum } from "@/types/FmsResourceAuthEnum";
import { YhAuth } from "@/components/auth/YhAuth";



export const BillSupplier = () => {

    const {
        dataSource,
        selectedRowKeys,
        billSummaryData,
        setOrgDs,
        setBeDs,
        // setAppDs,
        // setPayMethodDs,
        setPayMethodLabels,
        setSelectedData,
        loadData,
        billSupplierExport,
        exportLoading,
    } = useBillSupplierModel(model => [model.billSummaryData, model.exportLoading])

    const { getSelectedDict } = useGlobalModel(() => []);

    useEffect(() => {
        loadData();

        let obj: labelsType = {}
        orgService.orgTreeDs({}).then(ds => setOrgDs(ds))
        beService.beDs({}).then(ds => setBeDs(ds))
        getSelectedDict(DictCodeEnmu.SETTLE_TYPE).forEach(item => {
            obj[item.value] = item.label
        })
        setPayMethodLabels(obj);
    }, []);



    useEffect(() => {
        let filters = dataSource.filter(el => selectedRowKeys.length > 0 ? el.key === selectedRowKeys[0] : false);
        const selectedData = filters && filters.length > 0 ? filters[0] : undefined;
        setSelectedData(selectedData)
    }, [selectedRowKeys]);

    const desc: IDescription[] = [
        {
            label: "账单总额",
            value: billSummaryData?.totalBillAmount?.toFixed(2) ?? 0.00,
            color: DescriptionColorEnum.green
        },
        {
            label: "已核销总额",
            value: billSummaryData?.totalWriteoffAmount?.toFixed(2) ?? 0.00,
            color: DescriptionColorEnum.green
        },
        {
            label: "未核销总额",
            value: billSummaryData?.totalUnWriteoffAmount?.toFixed(2) ?? 0.00,
            color: DescriptionColorEnum.red
        },
        {
            label: "已开票总额",
            value: billSummaryData?.totalInvoiceAmount?.toFixed(2) ?? 0.00,
            color: DescriptionColorEnum.red
        },
    ]


    const onWriteoff = () => {
        // if (selectedRowKeys && selectedRowKeys.length > 0) {
        //     // setWriteoffDrawerVisible(true);
        // } else {
        //     message.error("请选择核销账户!");
        // }
    }

    const action = (
        <div>
            {/* <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    onClick={onWriteoff}
                >
                    核销
                </Button> */}
            <YhAuth resCode={ResourceAuthEnum.BILL_S_EX}>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    loading={exportLoading}
                    onClick={billSupplierExport}
                >
                    导出
                </Button>
            </YhAuth>
        </div>
    );

    return (
        <>
            <PageHeader />
            <YhBox title={"账单列表"} descriptions={desc} action={action}>
                <BillDataTable />
            </YhBox>
            <WriteoffDrawer />
        </>
    )
}